import type { WrapperProps } from "@/modules/companies/client/components/Wrapper/types"
import type { PagesRouterPage, PagesRouterPageProps } from "@/types"
import type { GetServerSideProps } from "next"

import { ArticleDetails } from "@/modules/companies/client/components/ArticleDetails/ArticleDetails"
import { Wrapper } from "@/modules/companies/client/components/Wrapper/Wrapper"
import { getServerSideArticleDetailsProps } from "@/modules/companies/client/utils/getServerSideArticleDetailsProps"

const CompanyArticleDetails: PagesRouterPage<WrapperProps> = props => (
  <Wrapper {...props}>
    <ArticleDetails />
  </Wrapper>
)

const getServerSideProps: GetServerSideProps<PagesRouterPageProps<WrapperProps>> = async context =>
  getServerSideArticleDetailsProps(context)

export { CompanyArticleDetails as default, getServerSideProps }
